const SvgComponent = (props) => (
  <svg viewBox="-3.5 -2 20 20" fill="none" {...props}>
    <rect width={5.2} height={16} rx={1} fill={props.fill || '#2D2C27'} />
    <rect x={7.8} width={5.2} height={16} rx={1} fill={props.fill || '#2D2C27'} />
  </svg>
);

export { SvgComponent as Pause };
